import React, { useState, useEffect, useContext } from 'react';
import './css/header.css';

import contact from '../../data/layouts/contact';
import { Link, useNavigate } from 'react-router-dom';
import { Store } from '../../Store';

const Header = ({ navigationMenu }) => {
  const navigate = useNavigate();

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { resentBread } = state;

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubMenu, setIsSubMenu] = useState(null);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsSubMenu(null);
  };

  const toggleSubMenu = (idx) => {
    setIsSubMenu(isSubMenu === idx ? null : idx);
  };

  const navigatePage = (url) => {
    setIsSubMenu(null);
    navigate(url);
    setIsMenuOpen(false);
  };

  const saveBreadcrumb = (title1, url1, title2, url2) => {
    const breadcrumb = [
      {
        title: title1,
        slug: url1,
      },
      {
        title: title2,
        slug: url2,
      },
    ];
    ctxDispatch({
      type: 'SET_BREADCRUMB',
      payload: breadcrumb,
    });
    localStorage.setItem('resentBread', JSON.stringify(breadcrumb));
    navigate(url2 ? url2 : url1);
  };

  return (
    <div>
      <header
        className={`d-flex header-transition ${
          isVisible ? 'header-fixed' : ''
        } `}
      >
        <div className="container navbar-area d-flex align-items-center">
          <nav className="navbar navbar-expand-lg">
            <Link to="/" title={contact.name}>
              <img
                src={contact.logo}
                alt={contact.name}
                className="logo_main"
                loading="lazy"
              />
            </Link>

            <div className="mobile_menu_open " onClick={toggleMenu}>
              <img
                src="/images/icons/icons8-menu-50.png"
                alt="menu icon"
                loading="lazy"
              />
            </div>

            <div
              className={`collapse navbar-collapse sub-menu-bar justify-content-end ${
                isMenuOpen ? 'show' : ''
              }`}
            >
              <ul id="nav" className="navbar-nav ms-auto ps-0">
                {navigationMenu.slice(1, 8).map((data, index) => (
                  <li key={data.id} className="nav-item position-relative">
                    <div
                      className="link-nav"
                      onClick={() =>
                        saveBreadcrumb(data.title, data.url, '', '')
                      }
                    >
                      <span className="d-block">
                        {data.title}
                        {data.children.length > 0 && (
                          <i
                            className="fas fa-chevron-down"
                            style={{ fontSize: '11px', paddingLeft: '5px' }}
                          ></i>
                        )}
                      </span>
                    </div>
                    <ul className="subnav position-absolute ps-0">
                      {data.children.map((item, itemIndex) => (
                        <li key={item.id}>
                          <div
                            className="link-subnav"
                            title={item.title}
                            onClick={() =>
                              saveBreadcrumb(
                                data.title,
                                data.url,
                                item.title,
                                item.url
                              )
                            }
                          >
                            {item.title}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
              <span
                onClick={() =>
                  document
                    .getElementById('enrollment')
                    ?.scrollIntoView({ behavior: 'smooth' })
                }
                className="btn ms-auto go-to-enrollment-form"
              >
                Đăng ký nhận tư vấn
              </span>
            </div>
          </nav>
        </div>
      </header>
      <div
        className={`mobile_menu_overlay ${isMenuOpen ? 'show' : ''}`}
        onClick={toggleMenu}
      ></div>
      <div
        className={`mobile_menu_wrapper ${
          isMenuOpen ? 'show_mobile_menu_wrapper' : ''
        }`}
      >
        <div className="d-flex justify-content-between align-items-center pe-2">
          <img
            src={contact.logo}
            alt={contact.name}
            className="logo-side-bar"
          />
          <span className="icon-close" onClick={toggleMenu}>
            ×
          </span>
        </div>
        <nav className="mobile_menu_nav mobile-menu">
          <ul>
            {navigationMenu.slice(1, navigationMenu.length - 1).map(
              (data, index) =>
                data.status === 'active' && (
                  <React.Fragment key={data.id || index}>
                    <li key={data.id} className="position-relative">
                      <div
                        className={`dropdown-btn ${
                          isSubMenu === index ? 'active' : ''
                        }`}
                        onClick={() => toggleSubMenu(index)}
                      >
                        <span onClick={() => navigatePage(data.url)}>
                          {data.title}
                        </span>
                        {data.children.length > 0 && (
                          <i
                            className={`icon-angle-down ${
                              isSubMenu === index ? 'rotate-up' : ''
                            }`}
                          ></i>
                        )}
                      </div>
                    </li>
                    <ul
                      className={`dropdown-container ${
                        isSubMenu === index ? 'show' : ''
                      }`}
                    >
                      {data.children.map((item, itemIndex) => (
                        <li key={item.id}>
                          <div
                            className="link-nav-mobile"
                            title={item.title}
                            onClick={() => navigatePage(item.url)}
                          >
                            {item.title}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </React.Fragment>
                )
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Header;
